<script setup lang="ts">
import { provide, computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import TheHeader from '@/components/TheHeader.vue'
import { ApiService } from './services/apiService'
import { MembersProcess } from './views/services/members-process'
import { DataValidatorService } from 'commons'

const route = useRoute()
const apiService = new ApiService()
const dataValidatorService = new DataValidatorService()
const membersProcess = new MembersProcess(dataValidatorService)

const showHeader = computed(() => {
  const hasApiKey = !!localStorage.getItem('apiKey')
  const isLoginPage = route.name === 'login'
  return hasApiKey && !isLoginPage
})

provide('apiService', apiService)
provide('membersProcess', membersProcess)
provide('dataValidatorService', dataValidatorService)
</script>

<template>
  <div>
    <TheHeader v-if="showHeader" />
    <main class="content-area">
      <RouterView />
    </main>
  </div>
</template>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100vh;
  font-family: Arial, sans-serif;
  background-color: #fff;

  display: flex;
  flex-direction: column !important;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
}

.content-area {
  padding: 20px;
  width: 100%;
  margin: 20px auto;
  box-sizing: border-box;
  flex-grow: 1;
  padding-top: 100px;
}

.app-header {
  height: 110px;
  padding: 20px 40px;
}
</style>
